import React, { useState, useEffect } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField } from 'src/components/core'
import { useSelector } from 'react-redux'

const HeaderSettingsLanguage = props => {
  const { classes, onButtonTextChange, isLoading } = props
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings

  const [resumeText, setResumeText] = useState('')
  const [startText, setStartText] = useState('')

  useEffect(() => {
    if (landingPageData?.localizations) {
      setResumeText(landingPageData.localizations.resumeButton || '')
      setStartText(landingPageData.localizations.startButton || '')
    }
  }, [landingPageData])

  const handleChangeResumeCourse = value => {
    setResumeText(value)
    onButtonTextChange('resume', value)
  }

  const handleChangeStartCourse = value => {
    setStartText(value)
    onButtonTextChange('start', value)
  }

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Typography className={classes.header}>Button language</Typography>
      </div>
      <div className={classes.courseDiv}>
        <CoreTextField
          value={resumeText}
          onChange={e => handleChangeResumeCourse(e.target.value)}
          fullWidth
          label="Resume Course"
          disabled={isLoading}
        />
      </div>
      <div className={classes.courseDiv}>
        <CoreTextField
          label="Start Course"
          value={startText}
          onChange={e => handleChangeStartCourse(e.target.value)}
          fullWidth
          disabled={isLoading}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsLanguage)
